export default class Busdata {
    Route_ID?:string 
    Direction?:string 
    Bus_ID?:string;
    Location?:any;
    Longitude?:string;
    Latitude?:string;
    
}
